module.exports = __webpack_public_path__ + "static/Background-voter-2.e75ab051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-voter-2.jpg
// module id = 479
// module chunks = 265584890008614